import { Injectable } from '@angular/core';
import { CustomHttp, ApiConstants } from '../../shared';
import { TitleRequests } from '../catalog-api/model/title-requests';

@Injectable()
export class TitleRequestsService {
    constructor(
        private customHttp: CustomHttp,
        private apiConstants: ApiConstants
    ) { }

    mapTitleRequests(titleRequest) {
        return {
            id: titleRequest.id,
            batchId: titleRequest.batch_id,
            batchDescription: titleRequest.batch_description,
            requestUser: titleRequest.request_user,
            completedByUser: titleRequest.completed_by_user,
            parrotId: titleRequest.parrot_id,
            title: titleRequest.title,
            link: titleRequest.link,
            country: titleRequest.country,
            year: titleRequest.year,
            network: titleRequest.network,
            note: titleRequest.note,
            state: titleRequest.state,
            createdOn: titleRequest.created_on,
            completedOn: titleRequest.completed_on,
            priority: 'medium'
        };
    }

    getTitleRequests(page: number = 0, type: string, batchIdOrDescription: string, country: string, network: string, year: string, contentType) {
        const uri = this.apiConstants.ENDPOINT_TITLE_REQUESTS +
            `?content_type=${contentType}&page=${page}&type=${type}${batchIdOrDescription ? '&batch=' + encodeURIComponent(batchIdOrDescription) : ''}` +
            `${country ? '&country=' + country : ''}` +
            `${network ? '&network=' + encodeURIComponent(network) : ''}${year ? '&year=' + year : ''}`;

        return this.customHttp.get(uri);
    }

    createTitleRequest(requestUser: string, titleRequest: TitleRequests) {
            const payload = {
            request_user: requestUser,
            title: titleRequest.title,
            parrotId: titleRequest.parrotId,
            imdb_id: titleRequest.imdbId,
            wikibase_id: titleRequest.wikibaseId,
            wikipage_id: titleRequest.wikipageId,
            tmdb_id: titleRequest.tmdbId,
            tvdb_id: titleRequest.tvdbId,
            justwatch_id: titleRequest.justwatchId,
            link: titleRequest.link,
            country: titleRequest.country,
            year: titleRequest.year,
            network: titleRequest.network,
            batchId: titleRequest.batchUUID,
            batch_description: titleRequest.batchDescription,
            note: titleRequest.note,
            content_type: titleRequest.contentType,
            content_sub_type: titleRequest.contentSubType ? titleRequest.contentSubType : 'Sports' // Ensure default
        };
        const uri = this.apiConstants.ENDPOINT_TITLE_REQUESTS;
        return this.customHttp.post(uri, payload);
    }

    updateTitleRequest(requestId: number, completingUser: string, state: 'APPROVED' | 'REJECTED', priority?: 'low' | 'medium' | 'high') {
        const uri = this.apiConstants.ENDPOINT_TITLE_REQUESTS +
            `/complete?request_id=${requestId}&completing_user=${completingUser}&state=${state}` +
            `${priority ? '&priority=' + priority : ''}`;

        return this.customHttp.post(uri, {});
    }

    updateTitleRequestName(requestId: number, title: string) {
        const uri = this.apiConstants.ENDPOINT_TITLE_REQUESTS +
            `/update_title?request_id=${requestId}&title=${encodeURIComponent(title)}`;

        return this.customHttp.put(uri, {});
    }

    getDatasourceMapping(parrotId: string) {
        const url = `/proxy?service=catalogapi&uri=/harvest/item/ds_mapping&parrot_id=${parrotId}`;
        return this.customHttp.get(url).then(res => {
            return res.mappings || [];
        }).catch(error => { console.log(error); return []; });
    }

    fetchParrotIDFromMeatdata(imdbId: string, wikibaseId: string, wikipageId: string, tmdbId: string, url: string) {

       // console.log(wikibaseId)
        if (!imdbId) {
            imdbId = ' ';
        }
        if (!wikibaseId) {
            wikibaseId = ' ';
        }
        if (!wikipageId) {
            wikipageId = ' ';
        }
        if (!tmdbId) {
            tmdbId = ' ';
        }

        const payload = {
            'query': {
                'bool': {
                    'should': [
                        {
                            'match': {
                                'data.external_mappings.wiki_id': wikipageId
                            }

                        },
                        {
                            'match': {
                                'data.external_mappings.imdb_id': imdbId
                            }

                        },
                        {
                            'match': {
                                'data.external_mappings.wikibase_id': wikibaseId
                            }

                        },
                        {
                            'match': {
                                'data.external_mappings.tmdb_id': tmdbId
                            }

                        }
                    ]


                }
            },
            '_source': [ 'parrot_id', 'title' ]
        };


        return JSON.stringify(payload);
    }



    fetchMetadataFromEnrich(imdbId: string, wikibaseId: string, wikipageId: string,  tmdbId: string, justwatchId: string, parrotId: string, catalogState: string, type: string, title: string) {

      //  console.log(type);
        const contentType = type.toLowerCase();
        const payload = {
            queryType: 'enrich',
            contentType: contentType,
            isProductionItem: true,
            ...(title ? { title: title } : {}),
            ...(parrotId ? { parrot_id: parrotId } : {}),
            ...(catalogState ? { catalog_state: catalogState } : {}),
            queryItems: {
                idList: [
                    {
                        wikibase_id: wikibaseId,
                        imdb_id: imdbId,
                        wiki_id: wikipageId,
                        tmdb_id: tmdbId,
                        justwatch_id: justwatchId,
                    }
                ]
            }
        };
        const url = `/proxy?service=catalogapi&uri=/harvest/enrich/metadata/${contentType}`;

        return this.customHttp.post(url, payload).then(res => {
            if (res && res.metadata && res.metadata.length > 0) {
                return { metadata: res.metadata[0] };
            }
            return null;
        }).catch(error => {
            console.log(error); return null;
        });
    }

    public getEnrichEndpointContentType(type: string) {
        return ['Show', 'Movie', 'Sport'].includes(type) ? 'tv' : 'talent';
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/title-requests/title-requests.service.ts